import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useJourneyListenedStore } from '@/stores/useJourneyListenedStore';
import { showToast } from '@/hooks/useToast';

export function useJourneyListenedSongs() {
  const { user } = useAuth();
  const store = useJourneyListenedStore();

  useEffect(() => {
    if (user?.id) {
      store.fetchListenedSongs(user.id);
    } else {
      // Limpa o estado quando não houver usuário
      store.clearState();
    }
  }, [user?.id]);

  const markAsListened = async (songId: number, isPremiumSong: boolean) => {
    if (!user?.id) {
      showToast('Faça login para marcar músicas como ouvidas', 'error');
      return;
    }
    await store.markAsListened(user.id, songId, isPremiumSong, user.tipo_de_conta);
  };

  const unmarkAsListened = async (songId: number) => {
    if (!user?.id) {
      showToast('Faça login para gerenciar músicas ouvidas', 'error');
      return;
    }
    await store.unmarkAsListened(user.id, songId);
  };

  return {
    listenedSongIds: user ? store.listenedSongIds : [],
    loading: store.loading,
    markAsListened,
    unmarkAsListened,
    progress: user ? store.progress : { total: 198, listened: 0, percentage: 0 }
  };
} 